// @ts-nocheck
import { fetchEventVisibilitySnapshot, saveActiveEventSnapshot } from '../event-access';

/**
 * Cok-aktif etkinlik: kullanicinin sayfalar arasi ORTAK etkinlik secimi.
 * Tek anahtar (`selectedActiveEventId`) tutulur; eski anahtarlar
 * (`activeEvent`, `b2bActiveEventId`) secimle birlikte guncellenir, boylece
 * henuz tasinmamis ekranlar bozulmaz.
 */
export const SELECTED_ACTIVE_EVENT_KEY = 'selectedActiveEventId';
export const ACTIVE_EVENT_SELECTION_CHANGED = 'active-event-selection-changed';

export const readSelectedActiveEventId = (): string => {
  try {
    return window.localStorage.getItem(SELECTED_ACTIVE_EVENT_KEY) || '';
  } catch {
    return '';
  }
};

export const writeSelectedActiveEventId = (eventId: string, options?: { silent?: boolean }) => {
  const id = String(eventId || '').trim();
  try {
    if (id) {
      window.localStorage.setItem(SELECTED_ACTIVE_EVENT_KEY, id);
      window.localStorage.setItem('b2bActiveEventId', id);
    } else {
      window.localStorage.removeItem(SELECTED_ACTIVE_EVENT_KEY);
    }
  } catch {
    // localStorage yoksa secim yalnizca bellekte (hook state) kalir.
  }
  if (id) {
    // Etkinlik degisince eski etkinligin yetki/gorunurluk bilgisi temizlenir; yenisi asagida yuklenir.
    saveActiveEventSnapshot({
      activeEventId: id,
      eventId: id,
      canSeeParticipants: undefined,
      canSeeVisitors: undefined,
      viewerRoles: undefined,
      event: { canSeeParticipants: undefined, canSeeVisitors: undefined, viewerRoles: undefined },
    });
    // Menu/rota yetkileri secilen etkinligin katilim durumuna gore yenilenir.
    fetchEventVisibilitySnapshot(id)
      .then((snapshot) => saveActiveEventSnapshot({ activeEventId: id, eventId: id, ...snapshot }))
      .catch(() => undefined);
  }
  if (!options?.silent && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ACTIVE_EVENT_SELECTION_CHANGED, { detail: { eventId: id } }));
  }
};

/** Liste icinde gecerli secimi cozer: kayitli secim listede yoksa ilk etkinlik. */
export const resolveSelectedEventId = (events: Array<{ id?: string }>, storedId: string): string => {
  if (!events.length) return '';
  if (storedId && events.some((event) => String(event?.id) === storedId)) return storedId;
  return String(events[0]?.id || '');
};
